/**
 * Tipo de documento enviado no upload (campo documentType / rotulo do processo).
 * Valores alinhados ao esperado pela API de blob / vehicle-attachments.
 */
export enum VehicleDocumentType {
  Identificacao = 'identificacao',
  /** Documentação de venda / transferência veicular */
  VendaVeicular = 'venda_veicular',
  Licenciamento = 'licenciamento',
  Seguro = 'seguro',
  InspecaoVeicular = 'inspecao_veicular',
  ContratoLocacao = 'contrato_locacao',
  NotaFiscal = 'nota_fiscal',
  Outros = 'outros'
}

/**
 * Tag curta do arquivo (ex.: CRLV) — campo `tag` no payload de upload.
 */
export enum VehicleDocumentTag {
  CRLV = 'CRLV',
  CRV = 'CRV',
  CNH = 'CNH',
  NotaFiscal = 'NotaFiscal',
  Comprovante = 'Comprovante',
  LaudoVistoria = 'LaudoVistoria',
  ATPV = 'ATPV',
  IPVA = 'IPVA',
  Outros = 'Outros'
}

export const VEHICLE_DOCUMENT_TYPE_OPTIONS: { value: VehicleDocumentType; label: string }[] = [
  { value: VehicleDocumentType.Identificacao, label: 'Identificação do veículo' },
  { value: VehicleDocumentType.VendaVeicular, label: 'Identificação / documentação de venda veicular' },
  { value: VehicleDocumentType.Licenciamento, label: 'Licenciamento' },
  { value: VehicleDocumentType.Seguro, label: 'Seguro' },
  { value: VehicleDocumentType.InspecaoVeicular, label: 'Inspeção / vistoria veicular' },
  { value: VehicleDocumentType.ContratoLocacao, label: 'Contrato de locação' },
  { value: VehicleDocumentType.NotaFiscal, label: 'Nota fiscal' },
  { value: VehicleDocumentType.Outros, label: 'Outros' }
];

export const VEHICLE_DOCUMENT_TAG_OPTIONS: { value: VehicleDocumentTag; label: string }[] = [
  { value: VehicleDocumentTag.CRLV, label: 'CRLV' },
  { value: VehicleDocumentTag.CRV, label: 'CRV (Cédula)' },
  { value: VehicleDocumentTag.CNH, label: 'CNH (condutor)' },
  { value: VehicleDocumentTag.NotaFiscal, label: 'Nota fiscal' },
  { value: VehicleDocumentTag.Comprovante, label: 'Comprovante' },
  { value: VehicleDocumentTag.LaudoVistoria, label: 'Laudo de vistoria' },
  { value: VehicleDocumentTag.ATPV, label: 'ATPV-e' },
  { value: VehicleDocumentTag.IPVA, label: 'IPVA' },
  { value: VehicleDocumentTag.Outros, label: 'Outros' }
];
